export default __webpack_public_path__ + "static/media/fredrick.48d29a8c.jpg";